import { ExternalLink } from 'lucide-react';
import { ShoppingBagIcon, FolderArrowDownIcon, ShoppingCartIcon } from '@heroicons/react/24/outline';
import Gradient from '../../../../empreenderUI/ui/Gradient';
import { Button } from '../../../../empreenderUI/ui/Button';
import FeatureContainer from '../../../../empreenderUI/ui/FeatureContainer';
import CentralAjuda from '../../../../empreenderUI/features/CentralAjuda';
import FeedBackBoss from '../../../../empreenderUI/features/FeedBackBoss';
import Footer from '../../../../empreenderUI/features/Footer';
import PerfilDash from '../../../../empreenderUI/features/PerfilDash';
import CardApps from '../../../../empreenderUI/features/CardApps';
import FrequentApps from '../../../../empreenderUI/features/FrequentApps';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DijitalIcon from '../../../../empreenderUI/ui/appsIcons/Dijital';
import EmpreenderStories from '../../../../empreenderUI/features/EmpreenderStories';
import { translations } from '../../../../utils/language';
import { isShopifyLoginDomain } from '../../../../utils/shopify-login';

const NewDashBoard = () => {
  const history = useHistory();
  const isShopifyLogin = isShopifyLoginDomain();
  const language = useSelector((state) => state.reducerLanguage);
  const lang = language?.data || 'pt';
  const login = JSON.parse(localStorage.getItem('depoimentos@login'));

  return (
    <div className='w-full h-[calc(100%-60px)] bg-white flex items-center justify-center text-gray-900'>
      <Gradient colors={['#D2122E', '#FFE600']} />

      <div className='size-full flex flex-col items-center relative'>
        <div className='size-full flex flex-col items-center pt-20 pb-0 custom-scroll overflow-y-auto'>
          <PerfilDash suportLink='https://suporte.com.br/dijital/pt' icon={<DijitalIcon className='size-full' />} color='#fff' name={login?.user?.name} appName='Dijital' appDescription={translations['appDescription'][lang]}>
            <Button variant="secondary" asChild className='bg-white/50'>
              <a href={`https://${login?.integration?.url}`} className='flex flex-row gap-1.5 leading-4' target='_blank' rel='noreferrer'>
                <ExternalLink className='size-3.5 text-gray-900' />
                {translations['loja'][lang]}
              </a>
            </Button>
          </PerfilDash>

          <div className='flex flex-col gap-6 items-center w-full'>
            <div className='flex flex-row flex-wrap items-center justify-center gap-4 max-w-5xl w-full mt-12'>
              <FeatureContainer useSwitch={false} icon={<ShoppingBagIcon className='size-6' strokeWidth={1.5} />} titulo={translations['sidebar-produtos'][lang]} descricao={translations['dash-produtos-desc'][lang]} onContainerClick={() => history.push('/produtos')} />
              <FeatureContainer useSwitch={false} icon={<FolderArrowDownIcon className='size-6' strokeWidth={1.5} />} titulo={translations['sidebar-galeria'][lang]} descricao={translations['dash-galeria-desc'][lang]} onContainerClick={() => history.push('/galeria')} />
              <FeatureContainer useSwitch={false} icon={<ShoppingCartIcon className='size-6' strokeWidth={1.5} />} titulo={translations['Pedidos'][lang]} descricao={translations['dash-pedidos-desc'][lang]} onContainerClick={() => history.push('/pedidos')} />
            </div>

            {!isShopifyLogin && <EmpreenderStories />}
            {!isShopifyLogin && <CardApps />}
            {!isShopifyLogin && <FrequentApps apps={['sak']} />}

            <CentralAjuda href='https://dijital.tawk.help/' />
            <FeedBackBoss feedbackLink={lang === 'pt' ? 'https://www.nuvemshop.com.br/loja-aplicativos-nuvem/dijital/rating' : 'https://www.tiendanube.com/loja-aplicativos-nuvem/dijital/rating'} description={translations['feedback-dash'][lang]} />
            <Footer suportLink='https://suporte.com.br/dijital/pt' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewDashBoard;
